var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn', 'btn-' + _vm.color, 'btn-sm'],style:(_vm.buttonStyle),attrs:{"type":"button"}},[_vm._v(" "+_vm._s(_vm.labelName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }